import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {httpRequestsOnErrorsActions, officeActions} from "store";
import {useHistory} from "react-router-dom";
import {createInputsWrapper, EmailValidator, ErrorText, useGlobalStyles, useGlobalText} from "utils";
import {AddressInput, CreateChancel, Line, ValidationInput, EditSaveButtons} from "components";
import moment from "moment";
import {officesInfoFragments} from "./styles";

export const Payment = ({handleChangeName, info}) => {
  const globalTextStyle = useGlobalText();
  const classes = officesInfoFragments();
  const globalStyles = useGlobalStyles();
  const globalScreens = createInputsWrapper();
  const dispatch = useDispatch();
  const history = useHistory();
  const [disables, setDisabled] = useState(!!info)
  const [fullAddress, setFullAddress] = useState(info ? info.address && info.address.formattedAddress : '')
  const [error, setError] = useState('')
  const [phone, setPhone] = useState(info ? info.phoneNumber : '')
  const [inputs, setInputs] = useState(info ? {...info} : {});

  const {httpOnLoad, httpOnError} = useSelector((state) => ({
    httpOnLoad: state.httpOnLoad,
    httpOnError: state.httpOnError
  }));

  const handleChange = e => setInputs(prevState =>
      ({...prevState, [e.target.name]: e.target.value,}),
    error === e.target.name && setError(''),
    e.target.name === 'name' && handleChangeName(e.target.value),
    httpOnError.length && dispatch(httpRequestsOnErrorsActions.removeError('CREATE_OFFICE'))
  );

  const handleChangePhone = (ev) => {
    if (ev.target.value.length <= 11) {
      setPhone(ev.target.value)
      error === 'phone' && setError('')
    }
  }
  const handleFullAddress = (ev) => {
    setFullAddress(ev)
    httpOnError.length && dispatch(httpRequestsOnErrorsActions.removeError('CREATE_OFFICE'))
    if (error === 'address') setError('')
  }
  const handleCreate = () => {
    const data = {
      "name": inputs.name,
      "email": inputs.email,
      "phoneNumber": phone,
      "establishedDate": new Date(inputs.establishedDate).getTime(),
      "address": fullAddress
    };

    const editData = {
      "name": inputs.name,
      "email": inputs.email,
      "phoneNumber": phone,
      "address": fullAddress,
      "officeId": info ? info.id : ''
    };

    if (inputs.name && inputs.email && phone && inputs.establishedDate && fullAddress) {
      if(info){
        dispatch(officeActions.editOffice(editData))
        setDisabled(true)
      }else{
        dispatch(officeActions.createOffice(data))
      }
    } else {
      setError(
        !inputs.name ? 'name' :
          !inputs.email ? 'email' :
            !phone ? 'phone' :
              !inputs.establishedDate ? 'date' :
                'address'
      )
    }
  }
  const errorText = httpOnError.length && httpOnError[0].error

  return (
    <div className={globalScreens.createInputsWrapper}>
      <div className={classes.editButton}>
        <EditSaveButtons
          type={'EDIT_PAYMENT'}
          handleChancel={() => setDisabled(true)}
          handleSetEdit={() => setDisabled(false)}
          handleSaveInfo={handleCreate}
        />
      </div>


      <div className={globalStyles.flexAble}>
       <Line height={'185px'}/>
        <div className={globalStyles.fullWidth}>
          <div className={globalScreens.basicInfo}>
            <div className={globalScreens.basicInfoInputs}>

              <ValidationInput
                style={globalStyles.simpleInput}
                variant={"outlined"}
                name={"paidAs"}
                type={"text"}
                label={"Paid As"}
                typeError={error === 'paidAs' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.paidAs}
                disabled={disables}
              />

              <ValidationInput
                style={globalStyles.simpleInput}
                variant={"outlined"}
                name={"taxId"}
                type={"text"}
                label={"Tax ID"}
                typeError={error === 'taxId' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.taxId}
                disabled={disables}
              />

              <ValidationInput
                style={globalStyles.simpleInput}
                variant={"outlined"}
                name={"fillingType"}
                type={"text"}
                label={"Filling Type"}
                typeError={error === 'fillingType' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.fillingType}
                disabled={disables}
              />
      <ValidationInput
                style={globalStyles.simpleInput}
                variant={"outlined"}
                name={"routingNumber"}
                type={"text"}
                label={"Routing Number"}
                typeError={error === 'routingNumber' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.routingNumber}
                disabled={disables}
              />

            </div>
          </div>

          <div className={globalScreens.basicInfo}>

            <div className={classes.basicInfoInputs}>
              <ValidationInput
                style={classes.simpleInput}
                variant={"outlined"}
                name={"accountNumber"}
                type={"text"}
                label={"Account Number"}
                typeError={error === 'accountNumber' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.accountNumber}
                disabled={disables}
              />
              <ValidationInput
                style={classes.simpleInput}
                variant={"outlined"}
                name={"eFSNumber"}
                type={"text"}
                label={"EFS Number"}
                typeError={error === 'eFSNumber' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.eFSNumber}
                disabled={disables}
              />


            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
